<template>
  <confirm-dialog
    :show="show"
    :message="message"
    @accept="changeStatus"
    @close="$emit('close')">
  </confirm-dialog>
</template>
 
<script>
import ConfirmDialog from '@/components/global/ConfirmDialog';

export default {
  props: {
    show: {
      type: Boolean,
      required: true,
    },
    ivrTemplate: {
      type: Object,
      required: true,
    },
  },
  components: {
    ConfirmDialog,
  },
  computed: {
    message() {
      return `¿Esta seguro de que desea ${this.ivrTemplate.status_id === 1 ? 'desactivar' : 'activar'} la plantilla ${this.ivrTemplate.name}?.`;
    },
  },
  methods: {
    changeStatus() {
      this.axios.patch(`ivr_templates/${this.ivrTemplate.id}`, {
        status_id: this.ivrTemplate.status_id === 1 ? 2 : 1,
      }).then((response) => {
        this.$emit('updated', response.data);
        this.$emit('close');
      }).catch(() => {});
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/ivr_v2/ChangeStatus.vue